import gql from 'graphql-tag';

const GET_AUDIO_FILES = gql`
  query AudioFiles($limit: Int, $cursor: String) {
    audioFiles(pagination: { limit: $limit, cursor: $cursor }) {
      edges {
        id
        fileName
        displayName
        mimetype
        path
        size
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

const UPLOAD_AUDIO = gql`
  mutation UploadAudio($audio: Upload!, $displayName: String) {
    uploadAudio(audio: $audio, displayName: $displayName) {
      id
      fileName
      displayName
      path
    }
  }
`;

const DELETE_AUDIO = gql`
  mutation DeleteAudio($id: ID!) {
    deleteAudio(id: $id)
  }
`;

export { GET_AUDIO_FILES, UPLOAD_AUDIO, DELETE_AUDIO };
